export let ActiveState = /*#__PURE__*/function (ActiveState) {
  ActiveState["On"] = "on";
  ActiveState["Off"] = "off";
  return ActiveState;
}({});
export let VisualState = /*#__PURE__*/function (VisualState) {
  VisualState["Lozenge"] = "lozenge";
  VisualState["FullPanel"] = "full-panel";
  return VisualState;
}({});
export let Product = /*#__PURE__*/function (Product) {
  Product["ServiceDesk"] = "serviceDesk";
  Product["Opsgenie"] = "opsgenie";
  return Product;
}({});

// This matches the envType in @atlassian-sox/analytics-web-client
export let Environment = /*#__PURE__*/function (Environment) {
  Environment["Local"] = "local";
  Environment["Dev"] = "dev";
  Environment["Staging"] = "staging";
  Environment["Prod"] = "prod";
  return Environment;
}({});
export let GspSectionKey = /*#__PURE__*/function (GspSectionKey) {
  GspSectionKey["Checklist"] = "checklist";
  GspSectionKey["ProductTours"] = "productTours";
  GspSectionKey["Home"] = "home";
  return GspSectionKey;
}({});
export let ChecklistTabKey = /*#__PURE__*/function (ChecklistTabKey) {
  ChecklistTabKey["Basics"] = "basics";
  ChecklistTabKey["TeamEfficiency"] = "teamEfficiency";
  ChecklistTabKey["Incidents"] = "incidents";
  ChecklistTabKey["Changes"] = "changes";
  ChecklistTabKey["Alerts"] = "alerts";
  return ChecklistTabKey;
}({});
export let ProductTourKey = /*#__PURE__*/function (ProductTourKey) {
  ProductTourKey["Welcome"] = "welcome";
  ProductTourKey["IncidentManagement"] = "incident-management";
  ProductTourKey["ChangeManagement"] = "change-management";
  return ProductTourKey;
}({});
export let HeaderState = /*#__PURE__*/function (HeaderState) {
  HeaderState["Minimized"] = "minimized";
  HeaderState["Expanded"] = "expanded";
  return HeaderState;
}({});
export let TaskId = /*#__PURE__*/function (TaskId) {
  TaskId["CreateItsmProject"] = "servicedesk-itsm-project-created";
  TaskId["CustomizePortal"] = "servicedesk-portal-name-customized";
  TaskId["AddPortalLogo"] = "servicedesk-logo-added-to-portal";
  TaskId["SetupEmailRequests"] = "servicedesk-email-requests-setup";
  TaskId["SetupChatRequests"] = "servicedesk-chat-requests-setup";
  TaskId["SetupServices"] = "servicedesk-services-setup";
  TaskId["AddTeamMember"] = "servicedesk-team-member-added";
  TaskId["GoBeyondBasics"] = "servicedesk-basics-documentation-accessed";
  TaskId["AutomateYourWork"] = "servicedesk-team-efficiency-automate-your-work";
  TaskId["SetupKnowledgeBase"] = "servicedesk-team-efficiency-setup-knowledge-base";
  TaskId["ConnectCiCdPipeline"] = "servicedesk-change-management-pipeline-connected";
  TaskId["AddChangeApprovers"] = "servicedesk-change-management-change-approvers-added";
  TaskId["TurnOnAutomationRules"] = "servicedesk-change-management-automation-rules-on";
  TaskId["MakeTheMostOfChangeManagement"] = "servicedesk-change-management-documentation-accessed";
  TaskId["SetupProfileForNotifications"] = "opsgenie-user-profile-notifications-setup";
  TaskId["SetupTeam"] = "opsgenie-response-team-setup";
  TaskId["AssignOwnerTeamToServices"] = "opsgenie-owner-team-assigned-to-service";
  TaskId["LevelUpIncidentManagement"] = "opsgenie-incident-management-documentation-accessed";
  TaskId["CustomizeRequestChannels"] = "servicedesk-request-channels-email-portal-requests-customised";
  TaskId["CustomizeRequestTypes"] = "servicedesk-request-types-customised";
  TaskId["ReviewQueueConfigurations"] = "servicedesk-queue-configurations-reviewed";
  TaskId["EnableOpsForTeam"] = "opsgenie-enable-ops-for-team";
  TaskId["ReviewOnCallSetup"] = "opsgenie-review-oncall-setup";
  TaskId["AddIntegration"] = "opsgenie-add-integration";
  TaskId["SetupOpsNotifications"] = "opsgenie-setup-ops-notifications";
  TaskId["ReviewAlerts"] = "opsgenie-review-alerts";
  return TaskId;
}({});
export const BasicsTaskIds = [TaskId.CreateItsmProject, TaskId.CustomizePortal, TaskId.AddPortalLogo, TaskId.SetupEmailRequests, TaskId.SetupServices, TaskId.AddTeamMember, TaskId.GoBeyondBasics];
export const BasicsTaskIdsProductionised = [TaskId.CreateItsmProject, TaskId.CustomizePortal, TaskId.SetupEmailRequests, TaskId.SetupChatRequests, TaskId.SetupServices, TaskId.AddTeamMember];
export const TeamEfficiencyTaskIds = [TaskId.AutomateYourWork, TaskId.SetupKnowledgeBase];
export const ChangesTaskIds = [TaskId.ConnectCiCdPipeline, TaskId.AddChangeApprovers,
// Not needed for GA release
// TaskId.TurnOnAutomationRules,
TaskId.MakeTheMostOfChangeManagement];
export const IncidentsTaskIds = [TaskId.SetupProfileForNotifications, TaskId.SetupTeam, TaskId.AssignOwnerTeamToServices, TaskId.LevelUpIncidentManagement];
export const AlertsTaskIds = [TaskId.EnableOpsForTeam, TaskId.ReviewOnCallSetup, TaskId.AddIntegration, TaskId.SetupOpsNotifications, TaskId.ReviewAlerts];
export let HasSeenReopenSpotlight = /*#__PURE__*/function (HasSeenReopenSpotlight) {
  HasSeenReopenSpotlight["Yes"] = "yes";
  HasSeenReopenSpotlight["No"] = "no";
  return HasSeenReopenSpotlight;
}({});
export let ContainerType = /*#__PURE__*/function (ContainerType) {
  ContainerType["Project"] = "project";
  return ContainerType;
}({});
export let ExplicitStringBoolean = /*#__PURE__*/function (ExplicitStringBoolean) {
  ExplicitStringBoolean["Yes"] = "yes";
  ExplicitStringBoolean["No"] = "no";
  return ExplicitStringBoolean;
}({});
export let PropertyKey = /*#__PURE__*/function (PropertyKey) {
  PropertyKey["VisualState"] = "visualState";
  PropertyKey["ActiveState"] = "activeState";
  PropertyKey["SectionState"] = "sectionState";
  PropertyKey["HasSeenReopenSpotlight"] = "hasSeenReopenSpotlight";
  return PropertyKey;
}({});

// Temporary solution as we don't have types in @atlassian-sox/analytics-web-client